import {makeStyles} from "@material-ui/core";

export default function useStyles() {
    return makeStyles((theme) => ({
        root: {
            width: '100%',
            maxWidth: 360,
            position: 'relative',
            overflow: 'auto',
            maxHeight: 150,
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        ul: {
            backgroundColor: 'inherit',
            padding: 0,
        },
        card: {
            minWidth: 275,
        },
        cardContent: {
            paddingRight: 0,
            padding: 0,
            position: 'relative'
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            fontSize: 14,
        },
        pos: {
            position: 'absolute',
            right: '7px',
            top: '7px',
            background: '#deac1e',
        
            borderRadius: '50%',
            width: "26px",
            height: "26px",
            '&:hover': {
                background: '#bd9112',

            }
        },  
        posText:{
            display: 'none',
            '&:hover': {
                display: 'inline',

            }
        },
        fab: {
            iconDelete: {
                margin: 2,
                fontSize: 32
            },
        },
        iconRemove: {
            color: '#ff7676 !important',
            cursor: 'pointer',
            '&:hover': {
                color: '#159B78 !important',
            },
        },
        iconEdit: {
            color: '#6b61ff !important',
            cursor: 'pointer',
            '&:hover': {
                color: '#159B78 !important',
            },
        },
        icons: {
            color: '#159B78 !important',
            width: '18px'
        },
        titleCartoes: {
            fontWeight: 'bold',
            paddingRight: 16,
            paddingLeft: 16,
            paddingTop: 4,
            paddingBottom: 8
        }
    }));
}